'use strict';

/**
 * appends params to a url
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} icon - icon that was clicked to add a product to the wishlist
*/
var displayMessageAndChangeIcon = function (data, icon, button, stopSpinner) {
    if (stopSpinner){
        $.spinner().stop();
    }
    var status;
    if (data.success) {
        status = 'alert-success';
        if (icon.hasClass('fa-heart-o')) {
            icon.removeClass('fa-heart-o').addClass('fa-heart');
        } else {
            icon.removeClass('fa-heart').addClass('fa-heart-o');
        }
    } else {
        status = 'alert-danger';
    }

    if ($('.notification-pop-up-messages').length === 0) {
        $('body').append(
            '<div class="notification-pop-up-messages "></div>'
        );
    }
    $('.notification-pop-up-messages')
        .append('<div class="notification-pop-up-alert text-center ' + status + '">' + data.msg + '</div>');

    setTimeout(function () {
        $('.notification-pop-up-messages').remove();
        if (button){
            button.removeAttr('disabled');
        }
    }, 5000);
}

module.exports = {
    
    displayMessageAndChangeIcon: displayMessageAndChangeIcon,
    rerenderWishList: function (renderURL, type){
        $.ajax({
            url: renderURL,
            type: 'get',
            data: {maxTiles: 3, type: type},
            success: function (data) {
                $('.wishlist-my-account').empty().append(data);
                $(window).trigger('resize');
            },
            error: function (err) {
                console.log('blargs error');
            }
        });
    },

    // refactor wishlist click, as it was duplicated 4 times.
    wishListHandleClick: function ($this, pid, url, button, stopSpinner, callback, isRemove){
        var icon = $this.find($('i'));
        var urlRemove = $this.data('remove-href');
        var optionId = $this.closest('.product-detail').find('.product-option').attr('data-option-id') || null;
        var optionVal = $this.closest('.product-detail').find('.options-select option:selected').attr('data-value-id') || null;
        var isAdd = icon.hasClass('fa-heart-o');
        isAdd = isAdd && !isRemove;
        var label = $this.attr(isAdd ? "data-remove-label" : "data-add-label");
        $.ajax({
            url: isAdd ? url : urlRemove,
            type: isAdd ? 'post' : 'get',
            dataType: 'json',
            data: {
                pid: pid,
                optionId: optionId,
                optionVal: optionVal
            },
            success: function (data) {
                displayMessageAndChangeIcon(data, icon, button, stopSpinner);
                if (label){
                    $this.attr('aria-label', label);
                }
                if (callback){
                    callback(data, isAdd);
                }
            },
            error: function (err) {
                displayMessageAndChangeIcon(err, icon, button, stopSpinner);
                if (label){
                    $this.attr('aria-label', label);
                }
            }
        });
    }
}